import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import React from "react";
import { useTranslation } from "react-i18next";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import ActionBar from "./components/ActionBar";
import ContentLayout from "./components/ContentLayout";
import StatCards from "./components/StatCards";
import { vehicleStatusesSaga } from "./redux/saga";
import { reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const VechileStatuses = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });
  useInjectSaga({ key: sliceKey, saga: vehicleStatusesSaga });

  return (
    <Box className={styles.container}>
      <Box className={styles.pageHeader} dir={i18n.dir()}>
        <BreadCrumb
          title={t("SIDEBAR.VEHICLE_STATUS")}
          iconPosition="end"
        />
      </Box>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <StatCards />
          <ActionBar />
          <ContentLayout />
        </Box>
      </Box>
    </Box>
  );
};

export default VechileStatuses;
